export const pageAnalytics = (pageName = "") => {
  window.analytics?.page?.(pageName);
};
export const pageAnalyticsIdentify = (user = {}) => {
  return user.id && window.analytics?.identify?.(user.id, {
    role: user.role,
    organization: user.organization
  });
};
